import { ChangeDetectorRef, Injectable, OnDestroy } from '@angular/core'

@Injectable()
export class CopyFeedbackService implements OnDestroy {
  copiedStates: { [key: string]: boolean } = {}
  private timers: { [key: string]: any } = {}

  // Pass `cdr` from OnPush hosts (or hosts with OnPush ancestors): one
  // markForCheck for the immediate icon swap — the click handler runs inside an
  // async Promise, so the post-microtask CD pass may not reach the host if an
  // OnPush ancestor isn't dirty — and another for the flicker-end transition
  // which runs from a setTimeout outside any Angular event.
  onCopied(key: string, cdr?: ChangeDetectorRef): void {
    this.copiedStates[key] = true
    cdr?.markForCheck()
    if (this.timers[key]) clearTimeout(this.timers[key])
    this.timers[key] = setTimeout(() => {
      this.copiedStates[key] = false
      delete this.timers[key]
      cdr?.markForCheck()
    }, 2000)
  }

  // Angular DI invokes ngOnDestroy on @Injectable() services when the providing
  // component is destroyed, so this clears any flicker timer that would otherwise
  // fire against an orphaned copiedStates after the host element is gone.
  ngOnDestroy(): void {
    for (const key of Object.keys(this.timers)) clearTimeout(this.timers[key])
    this.timers = {}
  }
}
